import {
  LOAD_PLUGIN_INSTALLATIONS_REQUEST_FAIL,
  LOAD_PLUGIN_INSTALLATIONS_REQUEST_START,
  LOAD_PLUGIN_INSTALLATIONS_REQUEST_SUCCESS,
  LOAD_PLUGINS_REQUEST_FAIL,
  LOAD_PLUGINS_REQUEST_START,
  LOAD_PLUGINS_REQUEST_SUCCESS, MICROPHONE_SET_AUDIO_RECORDING_IN_PROGRESS,
  MICROPHONE_SET_AUDIO_RECORDING_PERMISSION,
  MICROPHONE_SET_IS_AVAILABLE,
  MICROPHONE_SET_PERMISSION_INITIALLY_ASKED,
} from '../actions/Plugins'

import {NatsLocalClass} from "../Components/Nats";

const defaultState = {
  plugins: undefined,
  nats: new NatsLocalClass(),
  pluginInstallations: undefined,
  isSendingPluginsRequest: false,
  isSendingPluginInstallationsRequest: false,
  loadPluginsErrors: undefined,
  loadPluginInstallationsErrors: undefined,
  microphoneAvailable: undefined,
  microphonePermissionInitiallyAsked: false,
  microphoneHasPermission: undefined,
  microphonePermissionInProgress: false
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case LOAD_PLUGINS_REQUEST_START:
      return {
        ...state,
        isSendingPluginsRequest: true,
        loadPluginsErrors: undefined,
      };
    case LOAD_PLUGINS_REQUEST_SUCCESS:
      return {
        ...state,
        plugins: action.result,
        isSendingPluginsRequest: false,
      };
    case LOAD_PLUGINS_REQUEST_FAIL:
      return {
        ...state,
        loadPluginsErrors: action.error.message,
        isSendingPluginsRequest: false,
      };
    case LOAD_PLUGIN_INSTALLATIONS_REQUEST_START:
      return {
        ...state,
        isSendingPluginInstallationsRequest: true,
        loadPluginInstallationsErrors: undefined,
      };
    case LOAD_PLUGIN_INSTALLATIONS_REQUEST_SUCCESS:
      return {
        ...state,
        pluginInstallations: action.result,
        isSendingPluginInstallationsRequest: false,
      };
    case LOAD_PLUGIN_INSTALLATIONS_REQUEST_FAIL:
      return {
        ...state,
        loadPluginInstallationsErrors: action.error.message,
        isSendingPluginInstallationsRequest: false,
      };
    case MICROPHONE_SET_IS_AVAILABLE:
      if (action.data) {
        return {
          ...state,
          microphoneAvailable: action.data,
        };
      } else {
        return {
          ...state,
          microphoneAvailable: action.data,
          microphonePermissionInitiallyAsked: true,
          microphoneHasPermission: false,
          microphonePermissionInProgress: false,
        };
      }
    case MICROPHONE_SET_PERMISSION_INITIALLY_ASKED:
      return {
        ...state,
        microphonePermissionInitiallyAsked: action.data
      };
    case MICROPHONE_SET_AUDIO_RECORDING_PERMISSION:
      return {
        ...state,
        microphoneHasPermission: action.data
      };
    case MICROPHONE_SET_AUDIO_RECORDING_IN_PROGRESS:
      return {
        ...state,
        microphonePermissionInProgress: action.data,
      };

  }
  return state;
}
